export default {
  enabledWorkplaces: 'Enabled workplaces',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
};
